import React, { Component } from 'react';
import { AttachmentApi } from 'services/attachment';
import { connect } from 'react-redux';

class ScreenShot extends Component {
	screenShot = async () => {
		const { onClick, onSelect, width, height, sendAttachmentDetailsCG, ticketType } = this.props;
		const feedbackModal = document.getElementById('feedback-modal-selection-screen');
		const screenshot = document.getElementById('screenshot-wrapper');
		if (onClick) {
			onClick();
		}
		const screenshotJpegBlob = await this.takeScreenshotJpegBlob();
		const modalRoot = document.getElementById('screen-shot-root');
		const previewCanvas = await this.changeJpegBlobToCanvas(screenshotJpegBlob, width, height);
		previewCanvas.style.position = 'fixed';
		modalRoot.appendChild(previewCanvas);

		if (feedbackModal && screenshot) {
			feedbackModal.classList.add('screenshot-present');
			screenshot.classList.add('screenshot-present');
		}

		if (onSelect) {
			onSelect();
		}
		if (ticketType?.changegear) {
			const blobToBase64 = await this.blobToBase64(screenshotJpegBlob);
			const base64 = this.getBase64StringFromDataURL(blobToBase64);
			const attachment = {
				File: 'Feedback-Screenshot.jpg',
				Type: 'jpg',
				FileContent: base64,
			};

			sendAttachmentDetailsCG(attachment);
		}
		if (ticketType?.bonita) {
			this.sendAttachment(screenshotJpegBlob);
		}
	};

	componentWillUnmount() {
		const feedbackModal = document.getElementById('feedback-modal-selection-screen');
		const screenshot = document.getElementById('screenshot-wrapper');
		if (feedbackModal && screenshot) {
			feedbackModal.classList.remove('screenshot-present');
			screenshot.classList.remove('screenshot-present');
		}
	}

	blobToBase64 = blob => {
		return new Promise(resolve => {
			const reader = new FileReader();
			reader.onloadend = () => resolve(reader.result);
			reader.readAsDataURL(blob);
		});
	};

	sendAttachment = async blob => {
		const { sendAttachmentDetails, setLoading } = this.props;
		if (setLoading) {
			setLoading();
		}

		const attachment = await AttachmentApi.sendAttachmentBlob(blob);
		const { data: { data_id } = {} } = attachment;
		if (attachment.status === 200 && data_id) {
			this.setAttachmentInterval(data_id);
		} else {
			clearInterval(attachmentInterval);
			const error = 'Error scanning file.';
			const formattedAttachment = null;

			sendAttachmentDetails(formattedAttachment, error);
		}
	};

	setAttachmentInterval = data_id => {
		const { sendAttachmentDetails, auth_status } = this.props;
		let retrieveFile;
		const attachmentInterval = setInterval(async () => {
			retrieveFile = await AttachmentApi.getFileStatusFromML(data_id);
			if (retrieveFile.status === 200) {
				if (
					retrieveFile.data.process_info &&
					retrieveFile.data.process_info.progress_percentage === '100'
				) {
					if (
						retrieveFile.data.sanitized.result === 'Processing' ||
						retrieveFile.data.sanitized.result === 'Allowed'
					) {
						clearInterval(attachmentInterval);
						const { data: { data_id } = {} } = retrieveFile;

						const formattedAttachment = {
							user_id: auth_status.user.id,
							created_date_time: Date.now(),
							public_attachment: true,
							removed: false,
							attachment_location: data_id,
							filename: 'ScreenShot.jpg',
						};
						const error = null;

						sendAttachmentDetails(formattedAttachment, error);
					} else {
						clearInterval(attachmentInterval);
						const error = 'Threats detected or could not sanitize';
						const formattedAttachment = null;
						sendAttachmentDetails(formattedAttachment, error);
					}
				}
			} else {
				clearInterval(attachmentInterval);
				const error = 'Error scanning file.';
				const formattedAttachment = null;
				sendAttachmentDetails(formattedAttachment, error);
			}
		}, 2000);
	};

	changeJpegBlobToCanvas = (blob, width, height) => {
		return new Promise((resolve, reject) => {
			const img = new Image();
			img.onload = function bar() {
				const canvas = document.createElement('canvas');
				const scale = Math.min(1, width ? width / img.width : 1, height ? height / img.height : 1);
				canvas.width = img.width * scale;
				canvas.height = img.height * scale;
				const ctx = canvas.getContext('2d');
				ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas.width, canvas.height);
				resolve(canvas);
			};
			img.onerror = () => {
				reject(new Error('Error changing Jpeg blob to Image'));
			};
			img.src = URL.createObjectURL(blob);
		});
	};

	takeScreenshotJpegBlob = async () => {
		const canvas = await this.takeScreenshotCanvas();

		return this.getJpegBlob(canvas);
	};

	takeScreenshotCanvas = async () => {
		const mediaStream = await this.getScreenshotStream();

		const video = document.createElement('video');
		const result = await new Promise(resolve => {
			video.onloadedmetadata = () => {
				video.play();
				video.pause();
				const canvas = document.createElement('canvas');
				canvas.width = video.videoWidth;
				canvas.height = video.videoHeight;
				const context = canvas.getContext('2d');
				context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
				resolve(canvas);
			};
			video.srcObject = mediaStream;
		});

		mediaStream.getTracks().forEach(function foo(track) {
			track.stop();
		});

		if (result === null) {
			throw new Error('Cannot take canvas screenshot');
		}

		return result;
	};

	getJpegBlob = canvas => {
		return new Promise(resolve => {
			canvas.toBlob(
				blob => {
					resolve(blob);
				},
				'image/png',
				0.95,
			);
		});
	};

	getBase64StringFromDataURL = dataURL => dataURL.replace('data:', '').replace(/^.+,/, '');

	getScreenshotStream = async () => {
		const width = screen.width * (window.devicePixelRatio || 1);
		const height = screen.height * (window.devicePixelRatio || 1);
		const { onSelect } = this.props;
		const errors = [];
		let mediaStream;
		try {
			mediaStream = await this.getDisplayMedia({
				audio: false,
				video: {
					width,
					height,
					frameRate: 1,
				},
			});
		} catch (error) {
			errors.push(error);
		}

		if (errors.length) {
			console.debug(...errors);
			if (onSelect) {
				onSelect();
			}
			if (!mediaStream) {
				throw errors[errors.length - 1];
			}
		}

		return mediaStream;
	};

	getDisplayMedia = config => {
		if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
			return navigator.mediaDevices.getDisplayMedia(config);
		}
		if (navigator.getDisplayMedia) {
			return navigator.getDisplayMedia(config);
		}
		if (navigator.webkitGetDisplayMedia) {
			return navigator.webkitGetDisplayMedia(config);
		}
		throw new Error('Error:getDisplayMedia is not defined');
	};

	render() {
		return (
			<div className='screenshot-container '>
				<div
					className=' text body10'
					onClick={() => {
						this.screenShot();
					}}
					data-cy='screenshot-button'
				>
					Take a Screenshot
				</div>
				<div className='screenshot-root' id='screen-shot-root'></div>
			</div>
		);
	}
}
function mapStateToProps(state) {
	return {
		auth_status: state.auth_status,
	};
}

export default connect(mapStateToProps, null)(ScreenShot);
